let intervalId;
//const tabId = crypto.randomUUID(); // ✅ Un identifiant unique par onglet
const tabId = []
const channel = new BroadcastChannel("session_channel");
const TAB_LIST_KEY = "tabList";

export const initSessionManager = () => {
  const SESSION_TIMEOUT = 30 * 60 * 1000;
  const ACTIVITY_CHECK_INTERVAL = 5 * 60 * 1000;

  // ✅ Marque immédiatement le reload (avant tout)
  const isReload = sessionStorage.getItem("reloaded") === "true";
  sessionStorage.setItem("reloaded", "true"); // ← Ceci DOIT venir avant la vérification

  // ✅ Vérifie l'état de la session
  const existingTabListRaw = localStorage.getItem(TAB_LIST_KEY);
  let existingTabList = [];

  try {
    existingTabList = JSON.parse(existingTabListRaw || "[]");
  } catch (e) {
    console.warn("⚠️ Erreur parsing tabList:", e);
  }

  const sessionExists = !!localStorage.getItem("sessionId");

  // ✅ Si session existe mais tabList est vide et ce n’est pas un reload
  if (existingTabList.length === 0 && sessionExists && !isReload) {
    console.log("🧹 Session présente mais aucun onglet => clearSession()");
    clearSession();
    return;
  }

  // ✅ Enregistre ce tab dans tabList
  const currentList = JSON.parse(localStorage.getItem(TAB_LIST_KEY) || "[]");
  const newList = [...new Set([...currentList, tabId])];
  localStorage.setItem(TAB_LIST_KEY, JSON.stringify(newList));

  // ✅ Supprime ce tab à la fermeture
  window.addEventListener("beforeunload", () => {
    const list = JSON.parse(localStorage.getItem(TAB_LIST_KEY) || "[]");
    const updatedList = list.filter((id) => id !== tabId);
    localStorage.setItem(TAB_LIST_KEY, JSON.stringify(updatedList));

    channel.postMessage({ type: "tab_closed", from: tabId });
    // ❌ Ne supprime PAS "reloaded" ici ! (ça casse la détection du reload)
  });

  // ✅ Réagit aux modifications tabList des autres onglets
  window.addEventListener("storage", (event) => {
    if (event.key === TAB_LIST_KEY) {
      const newValue = JSON.parse(event.newValue || "[]");
      const oldValue = JSON.parse(event.oldValue || "[]");

      if (newValue.length < oldValue.length) {
        console.log("➖ Onglet fermé :", newValue);
      } else if (newValue.length > oldValue.length) {
        console.log("➕ Nouvel onglet ouvert :", newValue);
      }
    }
  });

  // ✅ Communication inter-onglets
  channel.onmessage = (event) => {
    const { type, from } = event.data || {};
    if (type === "tab_closed") {
      console.log(`📨 Message reçu de ${from}: fermeture d'un onglet`);
    }
  };

  // ✅ Activité utilisateur
  const updateActivity = () => {
    localStorage.setItem("lastActivity", Date.now().toString());
  };
  ["mousemove", "keydown", "scroll", "touchstart"].forEach((e) =>
    document.addEventListener(e, updateActivity, { passive: true })
  );
  updateActivity();

  intervalId = setInterval(() => {
    const last = parseInt(localStorage.getItem("lastActivity") || "0", 10);
    if (Date.now() - last > SESSION_TIMEOUT) {
      console.log("🔒 Session expirée (inactivité)");
      clearSession();
    }
  }, ACTIVITY_CHECK_INTERVAL);

  // ✅ Initialise la session si elle n'existe pas
  if (!localStorage.getItem("sessionId")) {
    localStorage.setItem("sessionId", crypto.randomUUID());
  }
  localStorage.setItem("browserSession", "active");
  localStorage.setItem("lastActivity", Date.now().toString());
  localStorage.setItem("sessionCheckInterval", intervalId.toString());
};

// 🔚 Nettoyage session
export const clearSession = () => {
  console.log("🧹 Nettoyage de session");

  const keys = [
    "browserSession",
    "sessionId",
    "lastActivity",
    "sessionCheckInterval",
    "authUser",
    "token",
    "roles",
    "user",
    "currentOrg",
    "logoOrg",
    "tabList",
    "idUser",
    "allRoles",
    "organizationName",
    "currentSolution",
    "docsPermission",
    "lmsPermission",
    "userRoles",
    "type",
    "types",
    "allCleanroom",
    "allCleanrooms",
    "cleanroom"
  ];

  keys.forEach((k) => localStorage.removeItem(k));
  if (intervalId) clearInterval(intervalId);

  if (window.location.pathname !== "/login") {
    window.location.href = "/login";
  }
};

export const clearSessionManually = () => {
  clearSession();
};

export const isSessionActive = () => {
  const sessionId = localStorage.getItem("sessionId");
  const last = parseInt(localStorage.getItem("lastActivity") || "0", 10);
  return !!sessionId && Date.now() - last < 30 * 60 * 1000;
};
